module.exports = __webpack_public_path__ + "static/media/eyeVNActive.c6cc72b3.png";